import React from 'react';
import { Container, Button, Typography, Grid } from '@mui/material';
import voca from 'voca';
import { Colors } from '../utils/Colors';
import { Icons } from '../utils/Icons';

interface IProps {
  response: string;
  count: number;
  add: React.MouseEventHandler<HTMLButtonElement>;
  subtract: React.MouseEventHandler<HTMLButtonElement>;
}

export function BanBookCounter({ response, count, add, subtract }: IProps) {
  return (
    <Container
      style={{
        backgroundColor: Colors.ocdWhite,
        border: `solid 1px ${Colors.silverSand}`,
        borderRadius: '5px',
        padding: 0
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        direction="row"
        spacing={0}
      >
        <Grid
          item
          justifyContent="center"
          style={{ borderRight: `solid 1px ${Colors.silverSand}` }}
        >
          <Button style={{ height: '100%' }} onClick={subtract}>
            {Icons.minus}
          </Button>
        </Grid>
        <Grid item xs={7} style={{ padding: '10px 0px 10px' }}>
          <Typography
            variant="h6"
            textAlign="center"
            style={{ color: Colors.skobeloff, fontSize: '11pt' }}
          >
            {voca.upperCase(response)}
          </Typography>
          <Typography
            variant="h4"
            textAlign="center"
            style={{
              color: Colors.richBlack,
              fontSize: '30pt',
              fontWeight: 'bold'
            }}
          >
            {count}
          </Typography>
        </Grid>
        <Grid
          item
          justifyContent="center"
          style={{ borderLeft: `solid 1px ${Colors.silverSand}` }}
        >
          <Button style={{ height: '100%', width: '100%' }} onClick={add}>
            {Icons.plus}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
